import { stdObject } from "../../../data/types/stdObject";
import { getCurrentDateTime } from "../../../utils/getCurrentDateTime";

export const addNewPayment = ({
  user,
  windowValues,
  setWindowValues,
}: stdObject) => {
  if (windowValues.QTY > 0 || windowValues.QTY < 0) {
    let tempValues = windowValues;
    console.log("tempValues", tempValues);
    tempValues.changed = true;

    const tempDate = tempValues.DATE ?? getCurrentDateTime();

    tempValues.records.unshift({
      FECDIN: tempDate.split("T").join(" "),
      TIPDIN: Number(windowValues.PAY),
      COBDIN: user.CODUSU,
      NOBDIN: user.NOMUSU,
      CANDIN: Number(windowValues.QTY),
      OBSDIN: windowValues.OBS ?? "",
    });
    tempValues.OBS = "";
    tempValues.QTY = "";
    tempValues.BAL =
      tempValues.info.TOT -
      tempValues.records
        .filter((e: stdObject) => !e.delete)
        .reduce((a: number, b: stdObject) => a + b.CANDIN, 0);
    setWindowValues({ ...tempValues });
  }
};
